import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'empty-root',
    templateUrl: './empty-route.component.html',
    styleUrls: ['./empty-route.component.scss'],
    imports: [CommonModule]
})
export class EmptyRouteComponent {
}
